import { takeEvery, put, call, select } from "redux-saga/effects";
import type { SagaIterator } from "redux-saga";
import { Api } from "../../api/api";
import { API_ENDPOINTS } from "../../api/endpoints";
import {
  fetchServices,
  fetchServicesSuccess,
  fetchServicesFailure,
  type Service,
} from "../slices/serviceSlice";
import type { RootState } from "../index";

// Fetch services saga
function* handleFetchServices(): SagaIterator<void> {
  try {
    // Get franchise info from Redux state
    const { franchiseId, userId, accountId }: { 
      franchiseId: string | null; 
      userId: string | null;
      accountId: string | null;
    } = yield select(
      (state: RootState) => state.service
    );
    
    if (!franchiseId || !userId) {
      yield put(fetchServicesFailure("Franchise ID and User ID are required"));
      return;
    }
    
    // Call API with custom headers
    // Note: Api.get signature is (url, params, headers)
    const response: { success: boolean; message: string; data: Service[]; error: null } = yield call(
      Api.get,
      API_ENDPOINTS.SERVICE.LIST,
      undefined, // params
      {
        franchise_id: franchiseId,
        user_id: userId,
        account_id: accountId || '',
      }
    );
    
    // Dispatch success action with service data from response.data
    yield put(fetchServicesSuccess(response.data));
  } catch (error: any) {
    // Dispatch failure action with error message
    const errorMessage = error?.response?.data?.message || error?.message || "Failed to fetch services";
    yield put(fetchServicesFailure(errorMessage));
    console.error("Fetch services error:", error);
  }
}

// Watcher saga - watches for fetchServices actions
export function* watchServices(): SagaIterator<void> {
  yield takeEvery(fetchServices.type, handleFetchServices);
}
